import React, { useState } from "react";
import { Button, FormControl } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useSnackbar } from "notistack";
import { useAxios } from "../../../contexts/AxiosProvider";
import { DataProcessorApi } from "../../../services/DataProcessorApi";
import { DatePicker, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { getEnvironmentConfig } from "../../../constants/CloudConstant";

const WorkflowNavigateSection = ({
  userData,
  workflow,
  value,
  handleChangeIndex,
  callDataProcessorFn,
  dataProcessorRefreshStatus,
}) => {
  const axios = useAxios();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [isRunDatePickerOpen, setIsRunDatePickerOpen] = useState(false);
  const [datePicked, setDatePicked] = useState("");

  const openDatePickerModal = () => {
    setDatePicked("");
    setIsRunDatePickerOpen(true);
  };
  const handleCancel = () => {
    setDatePicked("");
    setIsRunDatePickerOpen(false);
  };

  const executeDataProcessor = async (datePicked) => {
    try {
      setLoading(true);

      const data = {
        workflow_id: workflow.workflow_id,
        userId: userData.userId,
        username: userData.username,
        cloudEnvironment: getEnvironmentConfig().cloudEnvironment,
        workflow_run_date: datePicked,
      };

      const res = await DataProcessorApi.executeDataProcessorApi(axios, data);
      if (res.status === 200) {
        enqueueSnackbar(`${workflow.workflow_name} is running`, {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Something went wrong`, {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setLoading(false);
      setIsRunDatePickerOpen(false);
      navigate(-1);
    }
  };

  const onDateChange = (date, dateString) => {
    setDatePicked(dateString);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <FormControl>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{
              marginTop: "10px",
              marginRight: "7px",
              backgroundColor: "#00043C",
              "&:hover": { backgroundColor: "#00043C" },
            }}
            disabled
          >
            {dataProcessorRefreshStatus.cloudEnvironment}
          </Button>
        </FormControl>
        <LoadingButton
          size="large"
          type="submit"
          variant="outlined"
          loading={loading}
          sx={{
            marginTop: "10px",
            marginRight: "7px",
            backgroundColor: "#ffffff",
            "&:hover": { backgroundColor: "#ffffff" },
            color: "#00043C",
            border: "1px solid black",
          }}
          onClick={openDatePickerModal}
          disabled={dataProcessorRefreshStatus.runDisabled}
        >
          Run
        </LoadingButton>

        {value === 2 && (
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{
              marginTop: "10px",
              marginRight: "7px",
              backgroundColor: "#00043C",
              "&:hover": { backgroundColor: "#00043C" },
            }}
            onClick={() => callDataProcessorFn()}
            disabled={dataProcessorRefreshStatus.saveDisabled}
          >
            Submit
          </Button>
        )}
      </div>

      <Modal
        centered
        footer={null}
        title={<div style={{ textAlign: "center" }}>Select Date</div>}
        width={400}
        open={isRunDatePickerOpen}
        onCancel={handleCancel}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DatePicker
            format={{ format: "YYYY/MM/DD" }}
            onChange={onDateChange}
          />
          <LoadingButton
            size="large"
            type="submit"
            variant="outlined"
            loading={loading}
            sx={{
              marginTop: "10px",
              marginRight: "7px",
              backgroundColor: "#ffffff",
              "&:hover": { backgroundColor: "#ffffff" },
              color: "#00043C",
              border: "1px solid black",
            }}
            onClick={() => executeDataProcessor(datePicked)}
            disabled={datePicked === ""}
          >
            Run
          </LoadingButton>
        </div>
      </Modal>
    </>
  );
};

export default WorkflowNavigateSection;
